@if (accaBoostNotification()?.type === notificationTypeEnum.Error) {
    <bs-acca-boost-notification
        class="acca-boost-notification--error quick-bet-acca-boost-notification"
        [showAccaBoostIcon]="true"
        [showInfoIcon]="false"
        [notification]="accaBoostNotification()"
        [usLadderEnabled]="false"
        [class.acca-boost-notification-enhanced]="isEnhancedLayoutEnabled"
        @accaBoostNotificationAnimation>
        <bs-acca-boost-error
            [token]="accaBoostNotification()?.token"
            [error]="accaBoostNotification()?.error"
            [isTrendingAccas]="accaBoostNotification()?.isTrendingAccasSelected"></bs-acca-boost-error>
    </bs-acca-boost-notification>
}

@if (accaBoostNotification()?.type === notificationTypeEnum.OneSelectionAway) {
    <bs-acca-boost-notification
        class="acca-boost-notification--teaser quick-bet-acca-boost-notification"
        [notification]="accaBoostNotification()"
        [showInfoIcon]="false"
        [showAccaBoostIcon]="true"
        [usLadderEnabled]="false"
        [class.acca-boost-notification-enhanced]="isEnhancedLayoutEnabled"
        @accaBoostNotificationAnimation>
        <bs-acca-boost-teaser [token]="accaBoostNotification()?.token"></bs-acca-boost-teaser>
    </bs-acca-boost-notification>
}
